import axios from 'axios';
import store from '@/store';
const tokenTimeout = 4000;

let baseURL = process.env.VUE_APP_BASE_API;
const service = axios.create({
  // 设置超时时间
  timeout: tokenTimeout,
  baseURL,
  withCredentials: process.env.BASE_API_WithCredentials
  // withCredentials: false
  // withCredentials: true
});
service.defaults.headers.post['Content-Type'] = 'application/json';
service.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 */
service.interceptors.request.use(config => {
  // 可以在请求先展示加载框

  // 请求头带token
  const authToken = store.state.authToken;
  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */
service.interceptors.response.use(response => {
  // 请求响应后关闭加载框
  
  const responseCode = response.status;
  // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
  // 否则的话抛出错误
  if (responseCode === 200) {
    // console.log(response.config);
    return Promise.resolve(response.data);
  } else {
    return Promise.reject(response);
  }
}, error => {
  // 请求响应后关闭加载框
  // 断网 或者 请求超时 状态
  if (!error.response) {
    // 请求超时状态
    if (error.message.includes('timeout')) {
      // console.log('亲，网络不给力啊悲剧(＞﹏＜)');
      return Promise.reject(new Error('亲，网络不给力啊悲剧(＞﹏＜)'));
      // 消息提示框
    } else {
      // 可以展示断网组件
      return Promise.reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'));
      // console.log('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ');
      // 消息提示框
    }
  }
  // 服务器返回不是 2 开头的情况，会进入这个回调
  // 可以根据后端返回的状态码进行不同的操作
  // const responseCode = error.response.status;

  // switch (responseCode) {
  //     // 401 token过期
  //   case 401: 
  //     break;
  //     // 404请求不存在
  //   case 404:
  //     break;
  //     // 其他错误，直接抛出错误提示
  //   default:
  // }
  return Promise.reject(error);
});

export default service;

export const uploadFile = async (formData, url, time = 0) => {
  try {
    const res = await service.request({
      method: 'post',
      url: url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    // return res;
    if (res) {
      switch (res.code) {
        case 0:
          return res;
          break;
        case 401: // 401 token过期
        case 10110002: // 10110002 token过期已刷新过
          if (time <=2) {
            const getToken = new Promise((resolve, reject) => {
              // 调用app壳功能重新获取token,然后重新发送
              // eslint-disable-next-line
              uni.webView.postMessage({
                data: {
                  action: 'resetToken',
                  data: {
                    success: 'resetToken', // 成功回调方法名success(res接口返回序列化字符串)
                    authToken: store.state.authToken, // 现有authToken
                    error: 'TokenErr' // 失败回调方法名error(msg<报错信息字符串>)
                  }
                }
              });
              // 等待重置token,超时取消请求抛出错误
              const timeout = setTimeout(() => {
                window.resetToken = '';
                window.TokenErr = '';
                reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'));
              }, tokenTimeout);
              window.TokenErr = function(message) {
                window.resetToken = '';
                window.TokenErr = '';
                clearTimeout(timeout);
                reject(new Error(message));
              }
              window.resetToken = function(token) {
                try {
                  window.resetToken = '';
                  window.TokenErr = '';
                  clearTimeout(timeout);
                  resolve(token);
                } catch (error) {
                  clearTimeout(timeout);
                  reject(error);
                }
              }
            });
            const token = await getToken;
            store.commit('updateAuthToken', token);
            const nres = await uploadFile(formData, url, time + 1);
            return nres;
          } else {
            throw new Error(res.msg);
          }
          break;
        case 10110005:
        case 10110006:
          uni.webView.postMessage({
            data: {
              action: 'reLogin'
            }
          });
          throw new Error('登录异常');
          break;
        default:
          throw new Error(res.msg);
          break;
      }
    }
  } catch (error) {
    if (!(error.message.includes('亲，网络'))) {
      throw error;
    }
    if (time <=2 && (error.message.includes('亲，网络'))) {
      return uploadFile(formData, url, time + 1);
    }
  }
};

export const uploadFile2 = async (formData, url, time = 0) => {
  try {
    const res = await service.request({
      method: 'post',
      url: url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    // return res;
    if (res) {
      switch (res.code) {
        case 0:
          return res;
          break;
        case 401: // 401 token过期
        case 10110002: // 10110002 token过期已刷新过
          if (time <=2) {
            const getToken = new Promise((resolve, reject) => {
              // 调用app壳功能重新获取token,然后重新发送
              // eslint-disable-next-line
              uni.webView.postMessage({
                data: {
                  action: 'resetToken',
                  data: {
                    success: 'resetToken', // 成功回调方法名success(res接口返回序列化字符串)
                    authToken: store.state.authToken, // 现有authToken
                    error: 'TokenErr' // 失败回调方法名error(msg<报错信息字符串>)
                  }
                }
              });
              // 等待重置token,超时取消请求抛出错误
              const timeout = setTimeout(() => {
                window.resetToken = '';
                window.TokenErr = '';
                reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'));
              }, tokenTimeout);
              window.TokenErr = function(message) {
                window.resetToken = '';
                window.TokenErr = '';
                clearTimeout(timeout);
                reject(new Error(message));
              }
              window.resetToken = function(token) {
                try {
                  window.resetToken = '';
                  window.TokenErr = '';
                  clearTimeout(timeout);
                  resolve(token);
                } catch (error) {
                  clearTimeout(timeout);
                  reject(error);
                }
              }
            });
            const token = await getToken;
            store.commit('updateAuthToken', token);
            const nres = await uploadFile(formData, url, time + 1);
            return nres;
          } else {
            throw new Error(res.msg);
          }
          break;
        default:
          throw new Error(res.msg);
          break;
      }
    }
  } catch (error) {
    if (!(error.message.includes('亲，网络'))) {
      throw error;
    }
    if (time <=2 && (error.message.includes('亲，网络'))) {
      return uploadFile(formData, url, time + 1);
    }
  }
};